module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mode == 'info') ? _c('div', [_vm._v("\n  " + _vm._s(_vm.model[_vm.prop]) + "\n")]) : (_vm.mode == 'form') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model[_vm.prop]),
      expression: "model[prop]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.model[_vm.prop])
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterKey($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, _vm.prop, $event.target.value)
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aec4ba2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data-fields/text-field.vue
// module id = 136
// module chunks = 0